module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA2.2b82b3d0.jpg";